import "bootstrap-icons/font/bootstrap-icons.css";
import { Link } from "react-router-dom";
import "./productCategory.css";

import { FilterOutlined } from "@ant-design/icons";
import { Badge, Button, Dropdown, Input, Menu, Pagination, Popover, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAllBookPublisher } from "../../redux/actions/bookPublisher/getBookPublisherAction";

const FILTER_STYLE = { marginBottom: 12 };
const FILTER_LABEL = { display: "block", marginBottom: 4, color: "rgba(0,0,0,0.65)", fontSize: 12 };

const INITIAL_FILTERS = { name: "", address: "", phone: "", email: "" };

function CustomTable({ list, total, current, pageSize, filters, onFiltersChange, onChangePage, addBookPublisherButton, uploadButton }) {
  const dispatch = useDispatch();
  const [columnItems, setColumnItems] = useState([]);
  const [columnsToShow, setColumnsToShow] = useState([]);
  const [filterVisible, setFilterVisible] = useState(false);
  const [tableScrollY, setTableScrollY] = useState(400);
  const tableWrapRef = useRef(null);

  useEffect(() => {
    if (!tableWrapRef.current) return;
    const el = tableWrapRef.current;
    const ro = new ResizeObserver(() => {
      setTableScrollY(Math.max(200, el.clientHeight - 88));
    });
    ro.observe(el);
    setTableScrollY(Math.max(200, el.clientHeight - 88));
    return () => ro.disconnect();
  }, [list]);

  const activeFilterCount = [filters.name, filters.address, filters.phone, filters.email].filter(Boolean).length;
  const columns = [
    {
      title: "S.No",
      dataIndex: "sNo",
      key: "sNo",
      width: 70,
      render: (val) => val,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name, { id }) => (
        <Link to={`/book-publisher/${id}`}>{name}</Link>
      ),
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      ellipsis: true,
      render: (val) => val || "—",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (val) => val || "—",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      ellipsis: true,
      render: (val) => val || "—",
    },
  ];

  const menuItems = columns.map((item) => ({
    key: item.key,
    label: <span>{item.title}</span>,
  }));

  useEffect(() => {
    setColumnItems(menuItems);
    setColumnsToShow(columns);
  }, []);

  const colVisibilityClickHandler = (col) => {
    const ifColFound = columnsToShow.find((item) => item.key === col.key);
    if (ifColFound) {
      const filteredColumnsToShow = columnsToShow.filter(
        (item) => item.key !== col.key
      );
      setColumnsToShow(filteredColumnsToShow);
    } else {
      const foundIndex = columns.findIndex((item) => item.key === col.key);
      const foundCol = columns.find((item) => item.key === col.key);
      let updatedColumnsToShow = [...columnsToShow];
      updatedColumnsToShow.splice(foundIndex, 0, foundCol);
      setColumnsToShow(updatedColumnsToShow);
    }
  };

  const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

  const filterContent = (
    <div style={{ width: 280 }}>
      <div style={FILTER_STYLE}>
        <label style={FILTER_LABEL}>Name</label>
        <Input
          placeholder="Filter by name (searches all pages)"
          value={filters.name}
          onChange={(e) => onFiltersChange({ ...filters, name: e.target.value })}
          allowClear
        />
      </div>
      <div style={FILTER_STYLE}>
        <label style={FILTER_LABEL}>Address</label>
        <Input
          placeholder="Filter by address"
          value={filters.address}
          onChange={(e) => onFiltersChange({ ...filters, address: e.target.value })}
          allowClear
        />
      </div>
      <div style={FILTER_STYLE}>
        <label style={FILTER_LABEL}>Phone</label>
        <Input
          placeholder="Filter by phone"
          value={filters.phone}
          onChange={(e) => onFiltersChange({ ...filters, phone: e.target.value })}
          allowClear
        />
      </div>
      <div style={FILTER_STYLE}>
        <label style={FILTER_LABEL}>Email</label>
        <Input
          placeholder="Filter by email"
          value={filters.email}
          onChange={(e) => onFiltersChange({ ...filters, email: e.target.value })}
          allowClear
        />
      </div>
      <div style={{ textAlign: "center", marginTop: 8 }}>
        <Button
          size="small"
          onClick={() => onFiltersChange(INITIAL_FILTERS, true)}
        >
          Clear All Filters
        </Button>
      </div>
    </div>
  );

  return (
    <div className="card column-design list-page-fill-viewport">
      <div className="card-body">
        <div className="card-title d-flex justify-content-between align-items-center list-page-header" style={{ marginBottom: 0 }}>
          <h5 className="mb-0">Book Publisher List</h5>
          <div className="bpub-header-actions">
            {list && (
              <>
                <Popover
                  content={filterContent}
                  title="Filters"
                  trigger="click"
                  open={filterVisible}
                  onOpenChange={(open) => {
                    if (!open) onFiltersChange(filters, true);
                    setFilterVisible(open);
                  }}
                  placement="bottomLeft"
                >
                  <Badge count={activeFilterCount} size="small" offset={[-2, 2]}>
                    <Button
                      type="primary"
                      className="filter-icon-btn"
                      icon={<FilterOutlined />}
                      onClick={() => setFilterVisible((v) => !v)}
                      style={{
                        width: 36,
                        height: 36,
                        borderRadius: "50%",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    />
                  </Badge>
                </Popover>
                <Dropdown
                  overlay={<Menu onClick={colVisibilityClickHandler} items={columnItems} />}
                  placement="bottomRight"
                >
                  <Button className="column-visibility">Column Visibility</Button>
                </Dropdown>
              </>
            )}
            {addBookPublisherButton}
            {uploadButton}
          </div>
        </div>

        <div className="list-page-table-container">
          <div className="list-page-table-inner">
            <div ref={tableWrapRef} className="list-page-table-wrap">
              {/* Desktop Table */}
              <div className="d-none d-lg-block">
                <Table
                  scroll={{ x: true, y: tableScrollY }}
                  loading={!list}
                  pagination={{
                    current,
                    pageSize,
                    pageSizeOptions: [10, 20, 50, 100, 200],
                    showSizeChanger: true,
                    total,
                    onChange: (page, limit) => onChangePage(page, limit),
                  }}
                  columns={columnsToShow}
                  dataSource={
                    list
                      ? addKeys(list).map((row, index) => ({
                          ...row,
                          sNo: (current - 1) * pageSize + index + 1,
                        }))
                      : []
                  }
                />
              </div>

              {/* Mobile cards */}
              <div className="d-lg-none bpub-mobile-cards">
                {list && list.length > 0 ? (
                  <div className="row">
                    {list.map((record, idx) => (
                      <div key={record.id ?? idx} className="col-12 mb-2">
                        <div className="bpub-mobile-card card">
                          <div className="card-body">
                            <div className="bpub-mobile-row">
                              <span className="bpub-mobile-sno">{(current - 1) * pageSize + idx + 1}</span>
                              <Link to={`/book-publisher/${record.id}`} className="bpub-mobile-name">
                                {record.name}
                              </Link>
                            </div>

                            <div className="bpub-mobile-grid">
                              <div className="bpub-mobile-item">
                                <span className="bpub-mobile-label">Address</span>
                                <span className="bpub-mobile-value">{record.address || "—"}</span>
                              </div>
                              <div className="bpub-mobile-item">
                                <span className="bpub-mobile-label">Phone</span>
                                <span className="bpub-mobile-value">{record.phone || "—"}</span>
                              </div>
                              <div className="bpub-mobile-item">
                                <span className="bpub-mobile-label">Email</span>
                                <span className="bpub-mobile-value">{record.email || "—"}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-5">
                    <p className="text-muted mb-0">No Book Publishers found</p>
                  </div>
                )}

                {/* Mobile pagination to browse all pages */}
                {total > 0 && (
                  <div className="bpub-mobile-pagination">
                    <Pagination
                      current={current}
                      pageSize={pageSize}
                      total={total}
                      onChange={(page) => onChangePage(page, pageSize)}
                      showSizeChanger={false}
                      size="small"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const SEARCH_DEBOUNCE_MS = 400;

const GetAllBookPublisher = ({ refreshTrigger, addBookPublisherButton, uploadButton }) => {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.bookPublishers?.list);
  const total = useSelector((state) => state.bookPublishers?.total) ?? 0;
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const searchTimeoutRef = useRef(null);

  const fetchWithFilters = (page, limit, filterValues) => {
    dispatch(
      loadAllBookPublisher({
        page,
        limit,
        name: (filterValues.name || "").trim() || undefined,
        address: (filterValues.address || "").trim() || undefined,
        phone: (filterValues.phone || "").trim() || undefined,
        email: (filterValues.email || "").trim() || undefined,
      })
    );
  };

  useEffect(() => {
    fetchWithFilters(1, 10, filters);
    setCurrent(1);
  }, [dispatch, refreshTrigger]);

  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    };
  }, []);

  const handleFiltersChange = (newFilters, immediate = false) => {
    setFilters(newFilters);
    setCurrent(1);
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
      searchTimeoutRef.current = null;
    }
    if (immediate) {
      fetchWithFilters(1, pageSize, newFilters);
    } else {
      searchTimeoutRef.current = setTimeout(() => {
        fetchWithFilters(1, pageSize, newFilters);
        searchTimeoutRef.current = null;
      }, SEARCH_DEBOUNCE_MS);
    }
  };

  const handlePageChange = (page, limit) => {
    setCurrent(page);
    if (limit !== pageSize) setPageSize(limit);
    fetchWithFilters(page, limit, filters);
  };

  return (
    <CustomTable
      list={list}
      total={total}
      current={current}
      pageSize={pageSize}
      filters={filters}
      onFiltersChange={handleFiltersChange}
      onChangePage={handlePageChange}
      addBookPublisherButton={addBookPublisherButton}
      uploadButton={uploadButton}
    />
  );
};

export default GetAllBookPublisher;
